import { render } from "./vaccountset.vue?vue&type=template&id=de9d71b4&scoped=true"
import script from "./vaccountset.vue?vue&type=script&lang=js"
export * from "./vaccountset.vue?vue&type=script&lang=js"

import "./vaccountset.vue?vue&type=style&index=0&id=de9d71b4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de9d71b4"]])

export default __exports__